import { getTotal } from "./utils";

export const howCustomersSearch = ({ report }) => [
  {
    id: "hcs_total_searches",
    searchesBlock: {
      title: "Total Monthly Searches",
      description:
        "This chart tracks total monthly search volume over time, showing seasonal patterns and year-over-year trends in customer search behavior. The trend data helps identify peak seasons for planning marketing campaigns and content creation. Comparing previous 12 months to the last 12 months reveals whether overall market demand is growing or declining, informing long-term strategy decisions.",
      cols: ["Month", "Previous 12 Months", "Last 12 Months", "YOY Change"],
      fields: ["month", "previous", "last", "yoy"],
      sortField: "month",
      sortOrder: -1,
      container: true,
    },
  },
  {
    multiBlock: {
      id: "categories-searches-breakdown",
      items: [
        {
          id: "hcs_cat_break",
          chartBlock: {
            container: false,
            cols: ["Category", "Avg Monthly Volume"],
            fields: ["category", "volume"],
            sortField: "volume",
            sortOrder: -1,
            title: "Categories Searches Breakdown",
            description:
              "This comprehensive view shows average monthly search volume across different organizational levels - main categories, sub-categories, and customer types. The data reveals which market segments have the highest search demand, helping prioritize content creation and optimization efforts. Higher search volumes indicate larger market opportunities and greater potential traffic available for capture.",
            footer: [
              "Grand Total",
              getTotal({ report, sheet: "hcs_cat_break", field: "volume" }),
            ],
          },
        },
        {
          id: "hcs_sub_cat_break",
          chartBlock: {
            container: false,
            cols: ["Sub Category", "Avg Monthly Volume"],
            fields: ["category", "volume"],
            sortField: "volume",
            sortOrder: -1,
            footer: [
              "Grand Total",
              getTotal({ report, sheet: "hcs_sub_cat_break", field: "volume" }),
            ],
          },
        },
        {
          id: "hcs_location_break",
          chartBlock: {
            container: false,
            cols: ["Type", "Avg Monthly Volume"],
            fields: ["category", "volume"],
            sortField: "volume",
            sortOrder: -1,
            footer: [
              "Grand Total",
              getTotal({
                report,
                sheet: "hcs_location_break",
                field: "volume",
              }),
            ],
          },
        },
      ],
    },
  },
  {
    multiBlock: {
      id: "categories-searches-yoy",
      title: "Categories Searches Year On Year",
      description:
        "This analysis compares search volume changes between time periods to identify growing and declining market segments. Positive percentage changes indicate expanding opportunities, while negative changes suggest declining interest. This trend analysis helps identify emerging opportunities early and allows for strategic pivoting away from declining categories toward growth areas.",
      items: [
        {
          id: "hcs_cat_yoy",
          tableBlock: {
            container: false,
            cols: [
              "Category",
              "Previous 12 Months",
              "Last 12 Months",
              "YOY Change",
            ],
            fields: ["category", "prev", "last", "yoy"],
            sortField: "last",
            sortOrder: -1,
            paginator: true,
            footer: [
              "Grand Total",
              getTotal({ report, sheet: "hcs_cat_yoy", field: "prev" }),
              getTotal({ report, sheet: "hcs_cat_yoy", field: "last" }),
            ],
          },
        },
        {
          id: "hcs_sub_cat_yoy",
          tableBlock: {
            container: false,
            cols: [
              "Sub Category",
              "Previous 12 Months",
              "Last 12 Months",
              "YOY Change",
            ],
            fields: ["category", "prev", "last", "yoy"],
            sortField: "last",
            sortOrder: -1,
            paginator: true,
            footer: [
              "Grand Total",
              getTotal({ report, sheet: "hcs_sub_cat_yoy", field: "prev" }),
              getTotal({ report, sheet: "hcs_sub_cat_yoy", field: "last" }),
            ],
          },
        },
        {
          id: "hcs_location_yoy",
          tableBlock: {
            container: false,
            cols: [
              "Type",
              "Previous 12 Months",
              "Last 12 Months",
              "YOY Change",
            ],
            fields: ["category", "prev", "last", "yoy"],
            sortField: "last",
            sortOrder: -1,
            paginator: true,
            footer: [
              "Grand Total",
              getTotal({ report, sheet: "hcs_location_yoy", field: "prev" }),
              getTotal({ report, sheet: "hcs_location_yoy", field: "last" }),
            ],
          },
        },
      ],
    },
  },
];
